import { createRouter, createWebHistory } from 'vue-router';
import store from '../store/index.js';

import account from './modules/account';
import booking from './modules/booking';
import more from './modules/more';
// import service from './modules/service';
import trade from './modules/trade';

const routes = [
  ...account,
  ...booking,
  ...more,
  // ...service,
  ...trade,
  {
    path: '/',
    name: 'Home',
    redirect: {
      name: 'BookingIndex',
    },
  },
  {
    path: '/',
    name: 'Access',
    component: () => import('@/views/User/Access.vue'),
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/User/Login.vue'),
        beforeEnter: (to, from, next) => {
          let locale = to.query.locale;
          console.log("locale", locale);

          if(locale!==undefined){
            window.setAndroidLanguege(locale);
          }

          next();
        }
      },
      /*
      {
        path: '/login/:locale',
        name: 'Login1',
        component: () => import('@/views/User/Login.vue'),
        beforeEnter: (to, from, next) => {
          let locale = to.params.locale;

          window.setAndroidLanguege(locale);

          next();
        },
      },
      */
      {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/User/Register.vue'),
        },
        {
            path: '/token/:token',
            name: 'Token',
            component: () => import('@/views/User/Token.vue'),
        },
    ],
  },
  {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: () => import('@/views/User/ForgetPassword.vue'),
  },
  {
    path: '/verifyCode',
    name: 'VerifyCode',
    component: () => import('@/views/User/VerifyCode.vue'),
  },
  {
    path: '/resetPassword',
    name: 'ResetPassword',
    component: () => import('@/views/User/ResetPassword.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: {
      name: 'BookingIndex',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function isLogin() {
  return store.state.user.isAuthenticated;
}

router.beforeEach((to, from, next) => {
  if (to.matched.some((value) => value.meta.requiresAuth) && !isLogin()) {
    next({
      name: 'Login',
      query: { redirect: to.fullPath },
    });
  }

  // pass
  else {
    next();
  }
});
export default router;
